import { requestWrapper } from './reusable';

const config = require('../../config')();

export const provisionStore = (userToken, payload) => requestWrapper(
    userToken,
    config.storeAutomationStoreProvisioningResource,
    'post',
    undefined,
    payload,
);

export const decommissionStore = (userToken, storeId) => requestWrapper(
    userToken,
    `${config.storeAutomationStoreProvisioningResource}/${storeId}`,
    'delete',
);

export const getProvisionedStore = (userToken, storeId) => requestWrapper(
    userToken,
    `${config.storeAutomationStoreProvisioningResource}/${storeId}`,
    'get',
);

export const getProvisionedStores = (userToken) => requestWrapper(
    userToken,
    config.storeAutomationStoreProvisioningResource,
    'get',
);

export const provisionRegister = (userToken, payload) => requestWrapper(
    userToken,
    config.storeAutomationRegisterProvisioningResource,
    'post',
    undefined,
    payload,
);

export const getRegister = (userToken, storeId, registerId) => requestWrapper(
    userToken,
    `${config.storeAutomationRegisterProvisioningResource}/${storeId}/${registerId}`,
    'get',
);

export const decommissionRegister = (userToken, storeId, registerId) => requestWrapper(
    userToken,
    `${config.storeAutomationRegisterProvisioningResource}/${storeId}/${registerId}`,
    'delete',
);

export const getRegistersByStore = (userToken, storeId) => requestWrapper(
    userToken,
    `${config.storeAutomationRegisterProvisioningResource}/${storeId}`,
    'get',
);
